import { render, staticRenderFns } from "./my-pages-container.vue?vue&type=template&id=bb2ea970&"
import script from "./my-pages-container.vue?vue&type=script&lang=js&"
export * from "./my-pages-container.vue?vue&type=script&lang=js&"
import style0 from "./my-pages-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports